<div class="blogs-container">
  <div class="header">
    <div class="header-img-section">
      <img src="../../../assets/images/icon 09.jpg" alt="" />
    </div>
    <div class="title">
      <div class="main-title">Blogs</div>
      <div class="sub-title">Our take on all things that matter</div>
    </div>
    <div class="flex-spacer"></div>
    <div class="add-btn btn"></div>
  </div>
  <div class="blogs">
    <div class="heading">
      <div class="back-btn" (click)="onClickBack()">< blogs</div>
      <div class="title">Archives</div>
    </div>
    <a
      class="blog"
      *ngFor="let archive of archives"
      (click)="onClickArchive(archive)"
    >
      <div class="left">
        <div class="name">
          {{ archive.title }},
          <div class="date"> {{ archive.createdDate | date: "dd/MM/yyyy" }} </div>
        </div>
        <div class="description">
          {{ archive.description }}
        </div>
      </div>
      <div class="right">
        <div class="pdf-icon">
          <i class="fa-solid fa-file-pdf"></i>
        </div>
      </div>
      <div class="right" *ngIf="authService.isAdmin">
        <div class="delete-icon">
          <i class="fa-solid fa-trash-can" (click)="onClickDelete(archive, $event)"></i>
        </div>
      </div>
    </a>
  </div>
</div>
